import React from 'react';
import { displayIcon } from "variables/icons";

const ServiceCard = ({ service, onClick }) => {
  return (
    <div 
      className="cursor-pointer flex min-h-[430px] flex-col items-center rounded-sm bg-white px-6 py-10 text-center shadow-sm transition duration-200 hover:-translate-y-1 hover:shadow-md"
      onClick={onClick}
    >
      <div className="mb-7 flex h-36 w-36 items-center justify-center">
        <img
          src={service.image}
          alt={service.title}
          className="h-28 w-28 object-contain"
        />
      </div>

      <h3 className="min-h-[56px] text-xl font-bold leading-tight text-green-800">
        {service.title}
      </h3>

      <p className="mt-4 max-w-[220px] flex-1 text-base leading-7 text-gray-700">
        {service.description}
      </p>

      <button
        type="button"
        onClick={onClick}
        className="mt-7 flex h-12 w-12 items-center justify-center rounded-full border border-green-300 text-green-700 transition hover:bg-green-700 hover:text-white"
      >
        {displayIcon("ArrowRight")}
      </button>
    </div>
  );
};

export default ServiceCard;